module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(2 2)\"><circle cx=\"14\" cy=\"14\" r=\"15\" stroke=\"#4990E2\" stroke-width=\"2\"></circle><path fill=\"#4990E2\" d=\"M11.988 18.318l-2.552-3.372a.994.994 0 0 1 .193-1.394.994.994 0 0 1 1.395.193l1.679 2.217 4.222-6.78a.997.997 0 0 1 1.69 1.054l-4.988 8.007a.993.993 0 0 1-.8.468c-.016.002-.03.002-.046.002a.994.994 0 0 1-.793-.395z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-project-closed.svg
// module id = 874
// module chunks = 1